
import { defineComponent, ref, inject, onBeforeMount } from "vue";
// eslint-disable-next-line no-unused-vars
import IConfigurationService from "../interfaces/configuration_service";
// eslint-disable-next-line no-unused-vars
import IRegions, { IRegionFilters } from "@/interfaces/region_filters";

import router from "../router";

interface IRegionSelectorOption
{
	region: string
}

export default defineComponent({
	emits: ["authenticated"],
	setup()
	{
		const regionInputRef = ref<HTMLElementTagNameMap>();
		const configurationService = inject<IConfigurationService>("configurationService");
		
		const options = ref<IRegions>();
		const selectedOption = ref<IRegionSelectorOption>();
		const selectedRegion = ref<any>();
		
		const isDisabled = ref<boolean>(true);

		if (!configurationService)
		{
			throw new Error("Configuration service not initialised");
		}

		async function submit(evt:Event)
		{
			if (evt)
			{
				evt.preventDefault();
			}

			router.replace({ name: 'music' });
		}

		// Now getting the regions minus any online feis'
		function loadRegionFilters()
		{
			let regionFilters = configurationService?.getRegionFilters();
			if (regionFilters)
			{
				options.value = regionFilters;
			}
		}

		function onChange(event: any)
		{
			isDisabled.value = true;
			if (event.target.value)
			{
				// Just set the selected region so that we can use it later
				configurationService?.setSelectedRegion(event.target.value);

				selectedRegion.value = configurationService?.getSelectedRegion();
				isDisabled.value = false;
			}
		}
		
		onBeforeMount(function()
		{
			loadRegionFilters();
		});

		return {
			regionInputRef,
			submit,
			options,
			selectedOption,
			onChange,
			isDisabled
		};
	}
});
